import React from 'react';
import Button from 'fe-design-base/molecules/Button';

type Props = {
  timeIsActive: boolean;
  onResendCode: () => void;
  buttonText: string;
  dataTestId?: string;
  uxElement: string;
  isLoading?: boolean;
};

const CountdownButton = ({
  timeIsActive,
  onResendCode,
  buttonText,
  dataTestId,
  uxElement,
  isLoading,
}: Props) => (
  <Button
    fullWidth
    variant="secondary"
    onClick={onResendCode}
    disabled={timeIsActive}
    startIcon={timeIsActive ? 'TimeClock' : undefined}
    dataTestId={dataTestId}
    uxElement={uxElement}
    isLoading={isLoading}
  >
    {buttonText}
  </Button>
);

export default CountdownButton;
